export const defaultLayout = {
	id: 1,
	name: 'Default',
	is_default: true,
	is_active: true,
	layout: [
		{ i: 'new_customers', x: 0, y: 0, w: 2, h: 0.7 },
		{ i: 'total_invoices', x: 2, y: 0, w: 2, h: 0.7 },
		{ i: 'total_revenue', x: 4, y: 0, w: 2, h: 0.7 },
		{ i: 'total_expenses', x: 6, y: 0, w: 2, h: 0.7 },
		{ i: 'user_guide', x: 8, y: 0, w: 2, h: 0.7 },
		{ i: 'sales_invoices', x: 0, y: 2, w: 4, h: 2.2 },
		{ i: 'recent_transactions', x: 4, y: 2, w: 2.6, h: 2.2 },
		{ i: 'top_selling_products', x: 6.6, y: 2, w: 3.4, h: 1.1 },
		{ i: 'inventory_summary', x: 6.6, y: 2, w: 3.4, h: 1.1 },
	],
	globalFilters: {},
};

export const mockUserLayouts = [
	{
		id: 1,
		name: 'Sales Dashboard',
		is_default: true,
		is_active: true,
		layout: [
			{ i: 'new_customers', x: 0, y: 0, w: 2, h: 0.7 },
			{ i: 'total_invoices', x: 2, y: 0, w: 2, h: 0.7 },
			{ i: 'total_revenue', x: 4, y: 0, w: 2, h: 0.7 },
			{ i: 'total_expenses', x: 6, y: 0, w: 2, h: 0.7 },
			{ i: 'user_guide', x: 8, y: 0, w: 2, h: 0.7 },
			{ i: 'sales_invoices', x: 0, y: 2, w: 4, h: 2.2 },
			{ i: 'recent_transactions', x: 4, y: 2, w: 2.6, h: 2.2 },
			{ i: 'top_selling_products', x: 6.6, y: 2, w: 3.4, h: 1.1 },
			{ i: 'inventory_summary', x: 6.6, y: 2, w: 3.4, h: 1.1 },
		],
	},
	{
		id: 2,
		name: 'Inventory Dashboard',
		is_default: false,
		is_active: false,
		layout: [
			{ i: 'top_selling_products', x: 0, y: 0, w: 8, h: 6 },
			{ i: 'inventory_summary', x: 8, y: 0, w: 8, h: 6 },
		],
	},
	{
		id: 3,
		name: 'Finance Dashboard',
		is_default: false,
		is_active: false,
		layout: [
			{ i: 'total_expenses', x: 0, y: 0, w: 8, h: 4 },
			{ i: 'total_revenue', x: 8, y: 0, w: 8, h: 4 },
			{ i: 'recent_transactions', x: 0, y: 4, w: 16, h: 8 },
		],
	},
];

export const mockCards = [
	{
		id: 1,
		type: 'summary',
		category: 'Users & Business Reach',
		category_slug: 'users_and_business_reach',
		module: 'sales',
		sub_module: 'customers',
		title: 'New Customers',
		layout_card_id: 'new_customers',
		icon: 'user',
	},
	{
		id: 2,
		type: 'summary',
		category: 'Users & Business Reach',
		category_slug: 'users_and_business_reach',
		module: 'sales',
		sub_module: 'doctors',
		layout_card_id: 'total_doctors',
		icon: 'user',
		title: 'Total Doctors',
	},
	{
		id: 3,
		type: 'summary',
		category: 'Users & Business Reach',
		category_slug: 'users_and_business_reach',
		module: 'purchases',
		sub_module: 'vendor',
		layout_card_id: 'total_vendors',
		icon: 'user',
		title: 'Total Vendors',
	},

	{
		id: 4,
		type: 'summary',
		module: 'sales',
		category: 'Sales',
		category_slug: 'sales_activity',
		sub_module: 'sales_invoices',
		layout_card_id: 'total_invoices',
		icon: 'invoice',
		title: 'Total Invoices',
	},

	{
		id: 5,
		type: 'summary',
		category: 'Sales',
		category_slug: 'sales_activity',
		module: 'sales',
		sub_module: 'payment_receives',
		layout_card_id: 'total_revenue',
		icon: 'revenue',
		title: 'Total Revenue',
	},

	{
		id: 7,
		type: 'summary',
		category: 'Sales',
		category_slug: 'sales_activity',
		module: 'sales',
		sub_module: 'sales_invoices',
		layout_card_id: 'total_cancelled_orders',
		icon: 'orders',
		title: 'Total Cancelled Orders',
	},
	{
		id: 8,
		type: 'summary',
		category: 'Sales',
		category_slug: 'sales_activity',
		module: 'sales',
		sub_module: 'sales_invoices',
		layout_card_id: 'total_pending_orders',
		icon: 'orders',
		title: 'Total Pending Orders',
	},
	{
		id: 9,
		type: 'table',
		category: 'Sales',
		category_slug: 'sales_activity',
		module: 'sales',
		sub_module: 'sales_invoices',
		layout_card_id: 'sales_invoices',
		title: 'Sales Invoices',
	},

	{
		id: 6,
		type: 'summary',
		category: 'Account & Transactions',
		category_slug: 'accounts_and_transactions',
		module: 'purchase',
		sub_module: 'payment_made',
		layout_card_id: 'total_expenses',
		icon: 'calculator',
		title: 'Total Expenses',
	},

	{
		id: 14,
		type: 'tabs',
		category: 'Account & Transactions',
		category_slug: 'accounts_and_transactions',
		module: 'sales_and_purchase',
		sub_module: 'sales_and_purchase',
		layout_card_id: 'recent_transactions',
		title: 'Recent Transactions',
	},

	{
		id: 15,
		type: 'top_selling_products',
		category: 'Inventory Health Section',
		category_slug: 'inventory_health_section',
		module: 'inventory',
		sub_module: 'products',
		layout_card_id: 'top_selling_products',
		title: 'Top Selling Products',
		chartType: 'bar',
	},
	{
		id: 16,
		type: 'inventory_summary',
		category: 'Inventory Health Section',
		category_slug: 'inventory_health_section',
		module: 'inventory',
		sub_module: 'products',
		layout_card_id: 'inventory_summary',
		icon: 'Inventory Summary',
		title: 'Inventory Summary',
	},
	{
		id: 17,
		type: 'summary',
		category: 'Inventory Health Section',
		category_slug: 'inventory_health_section',
		module: 'inventory',
		sub_module: 'products',
		layout_card_id: 'item_catalog',
		icon: 'order',
		title: 'Item Catalog',
		chartType: 'progress_bar',
	},

	{
		id: 17,
		type: 'summary',
		category: 'User Guide',
		category_slug: 'user_guide',
		module: 'user',
		sub_module: 'user',
		layout_card_id: 'setup_guide',
		icon: 'user',
		title: 'User Guide',
	},
];

export const cardTableColumnConfig = {
	sales_invoices: [
		{
			title: '#',
			key: 'id',
		},
		{
			title: 'Customer',
			key: 'customer',
		},
		{
			title: 'Status',
			key: 'status',
		},
		{
			title: 'Amount',
			key: 'amount',
		},
	],
};

export const dateFilterOptions = [
	{ label: 'Todays', value: 'today' },
	{ label: 'This Week', value: 'this_week' },
	{ label: 'Last Week', value: 'last_week' },
	{ label: 'This Month', value: 'this_month' },
	{ label: 'Last Month', value: 'last_month' },
	{ label: 'Financial Year', value: 'financial_year' },
	{ label: 'Custom Date', value: 'custom_date' },
];

export const cardList = [
	{
		title: 'Users & Business Reach',
		cards: [
			{ title: 'Total Customers', type: 'total_customers', isChecked: true },
			{ title: 'New Customers', type: 'new_customers', isChecked: true },
			{ title: 'Total Doctors', type: 'total_doctors', isChecked: true },
			{ title: 'Total Vendors', type: 'total_vendors', isChecked: true },
		],
	},
	{
		title: 'Sales',
		cards: [
			{ title: 'Total Sales Invoices', type: 'total_sales_invoices', isChecked: false },
			{ title: 'Total Revenue', type: 'total_doctors', isChecked: true },
			{ title: 'Total Cancelled Orders', type: 'total_vendors', isChecked: true },
			{ title: 'Total Pending Orders', type: 'total_vendors', isChecked: true },
			{ title: 'Sales Invoices Management', type: 'total_vendors', isChecked: true },
		],
	},
	{
		title: 'Purchases',
		cards: [
			{
				title: 'Purchase Order Management',
				type: 'purchase_order_management',
				isChecked: false,
			},
			{ title: 'Total Purchase Orders', type: 'total_purchase_orders', isChecked: true },
			{ title: 'Upcoming Orders', type: 'upcoming_orders', isChecked: true },
			{ title: 'Total Upcoming Receives', type: 'total_upcoming_receives', isChecked: true },
			{ title: 'Total Pending Receives', type: 'total_pending_receives', isChecked: true },
			{ title: 'Pending Receive', type: 'pending_receive', isChecked: true },
			{
				title: 'Purchase Receive Management',
				type: 'purchase_receive_management',
				isChecked: true,
			},
		],
	},
	{
		title: 'Inventor Health Section',
		cards: [
			{ title: 'Top Selling Product', type: 'top_selling_product', isChecked: false },
			{ title: 'Item Catalog', type: 'item_catalog', isChecked: true },
			{ title: 'Inventory Summary', type: 'inventory_summary', isChecked: true },
		],
	},
	{
		title: 'Accounts & Transactions',
		cards: [
			{ title: 'Gross Profit', type: 'gross_profit', isChecked: false },
			{ title: 'Net Profit', type: 'net_profit', isChecked: true },
			{ title: 'Profit Margin %', type: 'profit_margin_%', isChecked: true },
			{ title: 'Recent Transaction', type: 'recent_transaction', isChecked: true },
			{
				title: 'Top Profit Generating Products',
				type: 'top_profit_generating_products',
				isChecked: true,
			},
			{ title: 'High Margin Products', type: 'high_margin_products', isChecked: true },
			{ title: 'Low Margin Products', type: 'low_margin_products%', isChecked: true },
			{ title: 'Total Expenses', type: 'total_expenses', isChecked: true },
			{ title: 'Returns Impact', type: 'returns_impact', isChecked: true },
			{ title: 'Monthly Profit Trend', type: 'monthly_profit_trend', isChecked: true },
			{ title: 'Overdue Amount', type: 'overdue_amount', isChecked: true },
		],
	},
];
